import * as heroIconsOutline from '@heroicons/react/24/outline'
import * as heroIconsSolid from '@heroicons/react/24/solid'

const iconsets = {
  outline: heroIconsOutline,
  solid: heroIconsSolid,
}

function renderHeroIcon(type = 'outline', icon) {
  const iconset = iconsets[type]

  return iconset[icon]
}

export default renderHeroIcon
